<app-bread-crumb [items]="[{text:'utilizadores'}]" [sectionTitle]="'Lista de Utilizadores'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <ng-box [boxIcon]="'fa fa-user'" [boxTitle]="'Utilizadores'">

        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">

          <ng-button *ngIf="isAdmin()" (click)="create()"
            [button]="{name:'nova utilizador', faIconClass:'fa fa-plus',color:'danger'}">
          </ng-button>

        </ng-container>

        <!-- box-content -->
        <ng-container class="ng-box-content">

          <!-- inicio da tabel -->
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let user of objects;index" ngChangeColorOnHover>

              <!-- <td class="text-center">
                  <img class="img-responsive profile-user-img img-circle" style="width: 80px;height: 80px;"
                    src="{{user.picture || 'http://localhost:4200/assets/Khuzela.png'}}" alt="Foto do Utilizador">
              </td>
               -->
              <td>
                <strong style="font-size: medium; color:#f35309">{{user.name}}</strong> <br>
              </td>

              <td>
                {{user.email}}
              </td>

              <td *ngIf="this.isAdminOrUserKhuzela()" [ngStyle]="{color: user.club?.color}">
                {{user.club?.name?user.club?.name:'Khuzela'}}
              </td> 
               
              <td *ngIf="user?.roles">
                <small class="label label-success">{{ user.roles[0]?.name }}</small>
              </td>         

              <ng-actions-table-bar *ngIf="isAdmin()">

                <ng-button title="Editar" (click)="edit(user)" [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                </ng-button>

                <ng-button title="Detalhe" (click)="detail(user)"
                  [button]="{faIconClass:'fa fa-eye',color:'danger'}"></ng-button>

                <ng-button title="Excluir" (click)="delete(user)"
                  [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>

              </ng-actions-table-bar>
            </tr>

          </ng-table>

          <!-- fim da tabela -->
          <ng-box-table-spinner class="overlay" *ngIf="isSpinnerLoading"></ng-box-table-spinner>

        </ng-container>
        <!-- fim do conteudo -->
      </ng-box>
      <!-- fim do box -->
    </div>
  </div>
</section>